document.addEventListener('DOMContentLoaded', function () {
  const menuTrigger = document.querySelector('[aria-controls="menu-drawer"]');
  const drawer = document.getElementById('menu-drawer');

  let openTimeout, closeTimeout;

  if (menuTrigger && drawer) {
    // Check if hover behavior should be enabled via data attribute
    const enableHover = menuTrigger.dataset.hoverEnabled === 'true';
    
    if (enableHover) {
      // Hover to open main menu
      menuTrigger.addEventListener('mouseenter', function () {
        clearTimeout(closeTimeout);
        openTimeout = setTimeout(() => {
          const expanded = menuTrigger.getAttribute('aria-expanded');
          if (!expanded || expanded === 'false') {
            menuTrigger.click();
          }
        }, 200); // Delay to avoid flicker
      });

      // Move away from drawer to close
      drawer.addEventListener('mouseleave', function () {
        clearTimeout(openTimeout);
        closeTimeout = setTimeout(() => {
          const closeBtn = drawer.querySelector('[aria-label="Close"]');
          if (closeBtn) closeBtn.click();
        }, 200);
      });
    }
    // If hover is disabled, the default click behavior will work
  }
});

// Button Dropdown Functionality
document.addEventListener('DOMContentLoaded', function() {
  const dropdownTriggers = document.querySelectorAll('.button-dropdown__trigger');
  
  dropdownTriggers.forEach(trigger => {
    const menu = trigger.nextElementSibling;
    
    // Toggle dropdown on click
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Close all other dropdowns
      document.querySelectorAll('.button-dropdown__menu.show').forEach(openMenu => {
        if (openMenu !== menu) {
          openMenu.classList.remove('show');
          openMenu.previousElementSibling.setAttribute('aria-expanded', 'false');
        }
      });
      
      // Toggle current dropdown
      const isOpen = menu.classList.contains('show');
      if (isOpen) {
        menu.classList.remove('show');
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        menu.classList.add('show');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
  
  // Close dropdown when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.button-dropdown')) {
      document.querySelectorAll('.button-dropdown__menu.show').forEach(menu => {
        menu.classList.remove('show');
        menu.previousElementSibling.setAttribute('aria-expanded', 'false');
      });
    }
  });
  
  // Close dropdown on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.button-dropdown__menu.show').forEach(menu => {
        menu.classList.remove('show');
        menu.previousElementSibling.setAttribute('aria-expanded', 'false');
      });
    }
  });
});

